// A few well-known mainnet mints for display names and the swap form's
// picker. Anything else is shown by its mint address and its on-chain
// decimals; a full token search over Jupiter's list is a later addition.

import { LST_MINTS } from '@thevault/sdk';

const LST_NAMES: Record<string, string> = {
  JitoSOL: 'Jito staked SOL, liquid staking',
  JupSOL: 'Jupiter staked SOL, liquid staking',
  mSOL: 'Marinade staked SOL, liquid staking',
  INF: 'Sanctum Infinity, liquid staking',
};

export interface KnownToken {
  symbol: string;
  name: string;
  decimals: number;
}

export const WSOL_MINT_B58 = 'So11111111111111111111111111111111111111112';
export const USDC_MINT_B58 = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';

export const KNOWN: Record<string, KnownToken> = {
  [WSOL_MINT_B58]: { symbol: 'SOL', name: 'Wrapped SOL, swappable', decimals: 9 },
  [USDC_MINT_B58]: { symbol: 'USDC', name: 'USD Coin', decimals: 6 },
  Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB: { symbol: 'USDT', name: 'Tether USD', decimals: 6 },
  JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN: { symbol: 'JUP', name: 'Jupiter', decimals: 6 },
  DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263: { symbol: 'BONK', name: 'Bonk', decimals: 5 },
  // The liquid staking tokens offered against SOL (docs/19-staking-plan.md section 3.4; sdk LST_MINTS).
  ...Object.fromEntries(LST_MINTS.map((l) => [l.mint, { symbol: l.symbol, name: LST_NAMES[l.symbol] ?? 'Liquid staking token', decimals: l.decimals }])),
};

export function symbolOf(mint: string): string {
  return KNOWN[mint]?.symbol ?? `${mint.slice(0, 4)}…${mint.slice(-4)}`;
}
